import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { AITokenUsageSummary } from "../../../models/ai-token-usage/ai-token-usage.model";

@Injectable({
  providedIn: 'root'
})
export class AITokenUsageService {
  private url: string;

  private sessionTokensSubject = new BehaviorSubject<number>(0);
  public sessionTokens$ = this.sessionTokensSubject.asObservable();

  private userTotalSubject = new BehaviorSubject<AITokenUsageSummary | null>(null);
  public userTotal$ = this.userTotalSubject.asObservable();

  constructor(private httpClient: HttpClient) {
    this.url = environment.api.API_ENDPOINT;
  }

  addSessionTokens(tokens: number): void {
    const current = this.sessionTokensSubject.value;
    this.sessionTokensSubject.next(current + tokens);
  }

  resetSession(): void {
    this.sessionTokensSubject.next(0);
  }

  getUserSummary(): Observable<AITokenUsageSummary> {
    const obs = this.httpClient.get<AITokenUsageSummary>(
      `${this.url}/ai-token-usage/user-summary`
    );
    obs.subscribe({
      next: (summary) => this.userTotalSubject.next(summary),
      error: () => {}
    });
    return obs;
  }

  getSessionTokens(sessionStart: string): Observable<{ totalTokens: number }> {
    return this.httpClient.get<{ totalTokens: number }>(
      `${this.url}/ai-token-usage/session`,
      { params: { sessionStart } }
    );
  }
}
